import { render } from "./CompanySwitcher.vue?vue&type=template&id=5d23ceaf&scoped=true"
import script from "./CompanySwitcher.vue?vue&type=script&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&lang=js"

import "./CompanySwitcher.vue?vue&type=style&index=0&id=5d23ceaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d23ceaf"]])

export default __exports__